import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SharedModule } from '@shared/shared.module';
import { AppealsAndGrievancesInformationService } from '../core/service/appeals-and-grievances-outcome.service';
import { CoreModule } from '@core/core.module';

@NgModule({
  imports: [
    CoreModule,
    SharedModule
  ],
  providers: [
    ConfirmationService,
    AppealsAndGrievancesInformationService,
    MessageService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FeatureModule { }
// should be filled with all the feature modules or deleted
